import { render, staticRenderFns } from "./m-address-display.vue?vue&type=template&id=3c147df6&scoped=true&"
import script from "./m-address-display.vue?vue&type=script&lang=ts&"
export * from "./m-address-display.vue?vue&type=script&lang=ts&"
import style0 from "./m-address-display.vue?vue&type=style&index=0&id=3c147df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c147df6",
  null
  
)

export default component.exports